<template>
  <div class="container" :style="customStyle">
    <div class="img-container">
      <img class="image" src="@/assets/images/call_in.png" alt="call" />
    </div>
    <div class="pn-container">
      <span class="pn-name">{{ phoneName }}</span>
      <span class="pn-number">{{ phoneNumber }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallFlowNumber',
  props: {
    phoneName: String,
    phoneNumber: String,
    customStyle: String
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 319px;
  height: 64px;
  background: #e0e4eb;
  border-radius: 5px;
  display: flex;
  flex-direction: row;

  .img-container {
    width: 85px;
    height: 100%;
    background-color: #dfe1e5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .image {
      width: 45px;
      height: 45px;
    }
  }

  .pn-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 25px;

    .pn-name {
      font-weight: 500;
      font-size: 24px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: $colorText;
    }

    .pn-number {
      font-weight: normal;
      font-size: 18px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: $colorPlaceholder;
      margin-top: 5px;
    }
  }
}
</style>
